import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Application from '../../../Application';
// import materialTabService from '../../../../services/requests/material-tab.service';
import Spinner from '../../../../components/LoadingStyles/Spinner';
import { standardList, countryList, brandList } from '../../../../app.values';
import './styles.scss';

import Input from '@components/Input';
import { setGroundDepth } from '@reducers/options/ground/actions';
import {
  setBondConditions,
  setConcreteConditions,
  setConcreteStrength as setGeneralConcreteStrength,
  setLightWeightConcrete
} from '@reducers/selectors/material/actions';
import { APP_TYPES, BRAND, APP_STATES } from '@config';
import { getConcreteStrengthValue, setConcreteStrengthValue } from '@reducers/web-services/material/actions';

import { unitLabel, unitTransform, mergeDeep } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { STRENGTH } from '@reducers/units';
import { SafetyBarrierObject } from '@object-generators/safety-barrier';

const CUSTOM = '7';

class Concrete extends Component {

  static propTypes = {
    type: PropTypes.string.isRequired,
    depth: PropTypes.number.isRequired
  };

  concreteStrengthValueInput = React.createRef();

  constructor(props) {
    super(props);

    let minValue = (this.props.countryId === countryList['Australia'] || this.props.countryId === countryList['New Zealand']) ? 20 : 25;
    this.state = {
      chosenStrength: props.chosenStrength,
      customStrength: {
        value: unitTransform(props.concreteStrengthValue || minValue).from(defaultUnits.STRENGTH).to(props.strengthUnit),
        units: props.strengthUnit
      }
    };
  }

  //componentDidMount() {
  //  this.fetchOptions();
  //}

  //componentDidUpdate(props) {
    // if (this.props.strengthUnit !== props.strengthUnit) {
    //   this.concreteStrengthValueInput.current.value = unitTransform(this.state.concreteStrengthValue || 0)
    //     .from(defaultUnits.STRENGTH)
    //     .to(this.props.strengthUnit);
    // }
  //}

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.appStatus === APP_STATES.LOADING_NEW_STATE && prevState.customStrength.value !== nextProps.concreteStrengthValue) {
      return { 
        customStrength: { 
          value: unitTransform(nextProps.concreteStrengthValue || 0).from(defaultUnits.STRENGTH).to(nextProps.strengthUnit),
          units: nextProps.strengthUnit
        }
      };
    }

    return null;
  }

  render() {
    return (
      <div className="calculation">
        {this.props.isPending && <Spinner/>}

        <section className="list-type">
          <h4>{APP_TEXTS.CONCRETE_STRENGTH.Content}<b>{this.isANZ ? ' f\'c' : ''}</b></h4>
          <label className="w-75 mr-2 mb-2 " htmlFor="chosenStrength">
            <Tooltip content={ this.getConcreteStrengthTooltip(this.props.designStandard) }>
            <select
              id="chosenStrength"
              name="chosenStrength"
              className="form-control w-50 mr-2"
              value={this.props.chosenStrength}
              onChange={e => {
                if (e.target.value === CUSTOM)
                {
                  let minValue = (this.props.countryId === countryList['Australia'] || 
                  this.props.countryId === countryList['New Zealand']) ? 20 : 25;
                  this.setState(mergeDeep({}, this.state, {customStrength: { 
                    value: unitTransform(minValue).from(defaultUnits.STRENGTH).to(this.props.strengthUnit)
                  }}));
                  //this.state.customStrength = mergeDeep({}, this.state.customStrength, {value: 0});
                  
                  this.props.setConcreteStrength(CUSTOM, minValue); // set selectors state
                  this.props.setConcreteStrengthValue(minValue); // set webServices state
                } else {
                  this.props.setConcreteStrength(e.target.value);
                  if (Number(this.props.designStandard) === standardList['EU'] || 
                      Number(this.props.designStandard) === standardList['AnnexC']) // update input textbox
                    this.props.getConcreteStrengthValue(e.target.value);
                }

              }}
            >
              {this.props.strengths && this.props.strengths.length && this.props.strengths.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>
                  { (Number(this.props.designStandard) === standardList['EU'] || 
                     Number(this.props.designStandard) === standardList['AnnexC']) ? 
                      n['RunName'] : 
                      (this.props.countryId === countryList['North America'] && this.isICC ?
                        unitTransform(n['RunName'] || 0).from(STRENGTH.POUND_PER_SQUARE_INCH).to(this.props.strengthUnit) :
                        unitTransform(n['RunName'] || 0).from(defaultUnits.STRENGTH).to(this.props.strengthUnit))
                  }
                </option>
              ))}
            </select>
            </Tooltip>

            {(Number(this.props.designStandard) === standardList['EU'] || Number(this.props.designStandard) === standardList['AnnexC']) &&
              (this.props.countryId === countryList['Australia'] || this.props.countryId === countryList['New Zealand']) &&
              BRAND === brandList.Ramset && (
                <span className="ml-1 mr-1">f'c</span>
            )}

            {(Number(this.props.designStandard) === standardList['EU'] || Number(this.props.designStandard) === standardList['AnnexC']) && 
              (<Tooltip content={ Number(this.props.designStandard) === standardList['AnnexC'] ? 
                APP_TOOLTIPS.TOOLTIP_CUSTOM_CONCRETE_STRENGTH_ANNEX_C.Content :
                APP_TOOLTIPS.TOOLTIP_CONCRETE_COMPREHENSIVE_STRENGTH.Content 
              }>
              {/* <input
                ref={this.concreteStrengthValueInput}
                className="form-control w-50 mr-2"
                onChange={e => {
                  let value;
                  let isValidNumber = 
                    e.target.value.indexOf(".") === e.target.value.lastIndexOf(".") && 
                    !isNaN(e.target.value.replace(e.target.value.indexOf("."), ""));
                  if (!e.target.value) // empty input
                    value = 0;
                  else if (!isValidNumber) // prevent letters from input
                    value = this.state.customStrength.value;
                  else 
                    value = unitTransform(Number(e.target.value), false)
                      .from(this.props.strengthUnit).to(defaultUnits.STRENGTH); // input digits
                  
                  // set local state (interface)
                  this.setState({
                    customStrength: { 
                      value: !e.target.value ? 
                        "" : 
                        (isValidNumber ? 
                          e.target.value : 
                          unitTransform(this.state.customStrength.value)
                            .from(this.state.customStrength.units)
                            .to(this.props.strengthUnit)
                        ), 
                      units: this.props.strengthUnit 
                    }
                  }); 
                  this.props.setConcreteStrength(CUSTOM, value); // set selectors state
                  this.props.setConcreteStrengthValue(value); // set webServices state
                }}
                value={ this.props.chosenStrength !== CUSTOM ?
                  unitTransform(this.props.concreteStrengthValue || 0).from(defaultUnits.STRENGTH).to(this.props.strengthUnit) :
                  (this.state.customStrength.value !== null && this.state.customStrength.value !== "" ? 
                    unitTransform(this.state.customStrength.value).from(this.state.customStrength.units).to(this.props.strengthUnit) : 
                    ""
                  )
                }
                readOnly={this.props.chosenStrength !== CUSTOM}
              /> */}
              <Input 
                id="custom-input"
                className="mr-2 custom-strength"
                onUpdate={e => {
                  let value;
                  let isValidNumber = 
                    e.indexOf(".") === e.lastIndexOf(".") && 
                    !isNaN(e.replace(e.indexOf("."), ""));
                  if (!e) // empty input
                  {
                    // value = 0;
                    value = (this.props.countryId === countryList['Australia'] || 
                    this.props.countryId === countryList['New Zealand']) ? 20 : 25; // default units
                  }
                  else if (!isValidNumber) // prevent letters from input
                    value = this.state.customStrength.value;
                  else 
                    value = unitTransform(Number(e), false)
                      .from(this.props.strengthUnit).to(defaultUnits.STRENGTH); // input digits
                  
                  // set local state (interface)
                  this.setState({
                    customStrength: { 
                      value: !e ? 
                        "" : 
                        (isValidNumber ? 
                          e : 
                          unitTransform(this.state.customStrength.value)
                            .from(this.state.customStrength.units)
                            .to(this.props.strengthUnit)
                        ), 
                      units: this.props.strengthUnit 
                    }
                  }); 
                  this.props.setConcreteStrength(CUSTOM, value); // set selectors state
                  this.props.setConcreteStrengthValue(value); // set webServices state
                }}
                type="number"
                value={ this.props.chosenStrength !== CUSTOM ?
                  unitTransform(this.props.concreteStrengthValue || 0).from(defaultUnits.STRENGTH).to(this.props.strengthUnit) :
                  (this.state.customStrength.value !== null && this.state.customStrength.value !== "" ? 
                    unitTransform(this.state.customStrength.value).from(this.state.customStrength.units).to(this.props.strengthUnit) : 
                    ""
                  )}
                disabled={this.props.chosenStrength !== CUSTOM && true}
                maxValue={(this.props.countryId === countryList['Australia'] || this.props.countryId === countryList['New Zealand']) ?
                  unitTransform(50).from(defaultUnits.STRENGTH).to(this.props.strengthUnit) :
                  unitTransform(60).from(defaultUnits.STRENGTH).to(this.props.strengthUnit)}
                minValue={(this.props.countryId === countryList['Australia'] || this.props.countryId === countryList['New Zealand']) ?
                  unitTransform(20).from(defaultUnits.STRENGTH).to(this.props.strengthUnit) :
                  unitTransform(25).from(defaultUnits.STRENGTH).to(this.props.strengthUnit)}
              />
              
              </Tooltip>
            )}

            <span className="p-0">{unitLabel(this.props.strengthUnit)}</span>
          </label>

          {this.props.type !== Application.types.REBAR_REINFORCEMENT &&
           this.isICC && (
            <div className="calculation__row">
              <div className="custom-control custom-checkbox">
               <Tooltip content={APP_TOOLTIPS.TOOLTIP_OPTION_LIGHTWEIGHT_CONCRETE.Content}>
                <input
                  className="custom-control-input"
                  id="lightWeightConcreteActive"
                  name="lightWeightConcreteActive"
                  type="checkbox"
                  defaultChecked={this.props.isLightWeightConcrete}
                  onChange={e => this.props.setLightWeightConcrete(e.target.checked, this.props.lightWeightConcreteLambda)}
                />
                </Tooltip>

                <label
                  className="custom-control-label"
                  htmlFor="lightWeightConcreteActive"
                >
                  {APP_TEXTS.LIGHT_WEIGHT_CONCRETE.Content}
                </label>
              </div>

              <Tooltip content={APP_TOOLTIPS.TOOLTIP_MODIFICATION_FACTOR_LAMBDA.Content}>
              <Input
                id="lightWeightConcrete"
                prefix="&lambda; = "
                type="number"
                disabled={!this.props.isLightWeightConcrete}
                value={this.props.lightWeightConcreteLambda}
                onUpdate={value => this.props.setLightWeightConcrete(this.props.isLightWeightConcrete, value)}
              />
              </Tooltip>
            </div>
          )}

          {this.props.type !== Application.types.REBAR_REINFORCEMENT && (
            <div className="mb-2">
              <h4>{APP_TEXTS.CONDITIONS_OF_CONCRETE.Content}</h4>
              <label htmlFor="chosenCondition">
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_CONDITIONS_OF_CONCRETE.Content}>
                <select
                  id="chosenCondition"
                  name="chosenCondition"
                  className="form-control w-75 mr-2"
                  value={this.props.chosenCondition}
                  onChange={e => this.props.setConcreteConditions(e.target.value)}
                >
                  {this.props.conditions && this.props.conditions.length && this.props.conditions.map(n => (
                    <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                  ))}
                </select>
               </Tooltip>
              </label>

              {this.isANZ && (Number(this.props.designStandard) !== standardList['AS5216']) &&
                <p>{APP_TEXTS.CRACKED_CONCRETE_METHODS.Content}</p>
              }
            </div>
          )}

          <h4>{APP_TEXTS.THICKNESS_OF_CONCRETE.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_THICKNESS_OF_CONCRETE.Content}>
          <Input
            id="thickness"
            postfix={unitLabel(this.props.distanceUnit)}
            type="number"
            minValue={0}
            value={unitTransform(this.props.depth).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
            onUpdate={value => {
              this.props.setDepth(value, this.props.distanceUnit);
            }}
            disabled={!this.props.isThicknessEnabled && true}
          />
          </Tooltip>

          {this.isBondConditions && (
            <div>
              <h4>{APP_TEXTS.BOND_CONDITIONS.Content}</h4>
              <label htmlFor="chosenBond">
                <select
                  id="chosenBond"
                  name="chosenBond"
                  className="form-control w-75 mr-2"
                  defaultValue={this.props.chosenBond}
                  onChange={e => this.props.setBondConditions(e.target.value)}
                >
                  {this.props.bonds && this.props.bonds.length && this.props.bonds.map(n => (
                    <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                  ))}
                </select>
              </label>
            </div>
          )}
        </section>
      </div>
    );
  }

  //fetchOptions() {
  //  Promise.all([
  //    materialTabService.getConcreteStrength(),
  //    materialTabService.getConcreteConditions(),
  //    materialTabService.getBondConditions()
  //  ])
  //    .then(([strengths, conditions, bonds]) => {
  //      this.bonds = bonds;
  //      this.conditions = conditions;
  //      this.strengths = strengths;

  //      if (!this.state.chosenStrength) {
  //        this.setState({
  //          chosenStrength: this.strengths[0]['InternalName']
  //        });
  //      }
        
  //      if(this.props.designStandard === standardList['EU'])
  //        this.getConcreteStrengthValue(this.state.chosenStrength);
  //    })
  //    .then(this.unsetPending, this.unsetPending);
  //}

  // getConcreteStrengthValue(concreteStrength) {
  //   materialTabService.getConcreteStrengthValue(concreteStrength).then(res => {
  //     this.setState({
  //       concreteStrengthValue: res
  //     });
      
  //     if (this.props.designStandard === standardList['EU'])
  //       this.concreteStrengthValueInput.current.value = this.state.concreteStrengthValue;
  //   });
  // }

  unsetPending = () => this.setState({ isPending: false });

  get isBondConditions () {
    return (
      this.props.type === Application.types.REBAR_REINFORCEMENT && 
      Number(this.props.designStandard) !== standardList['ANZ'] &&
       Number(this.props.designStandard) !== standardList['AS5216'] &&
       Number(this.props.designStandard) !== standardList['AS3600']
    );
  }

  get isICC() {
    return (
      Number(this.props.designStandard) === standardList['ICC.Post'] ||
      Number(this.props.designStandard) === standardList['ICC.Cast'] 
    );
  }

  get isANZ() {
    return (
      Number(this.props.designStandard) === standardList['ANZ'] ||
      Number(this.props.designStandard) === standardList['AS5216'] ||
      Number(this.props.designStandard) === standardList['AS3600'] 
    );
  }

  getConcreteStrengthTooltip(designStandard) {
    switch (Number(designStandard))
    {
      case standardList['ICC.Cast']:
      case standardList['ICC.Post']:
      case standardList['CSA']: 
      {
        return APP_TOOLTIPS.TOOLTIP_CONCRETE_STRENGTH_ICC.Content;
      }
      case standardList["AS5216"]:
      case standardList["ANZ"]:
      case standardList["AS3600"]: 
      {
        return APP_TOOLTIPS.TOOLTIP_CONCRETE_STRENGTH_AS_ANZ_EU.Content;
      }
      case standardList["EU"]: 
      case standardList["AnnexC"]: 
      default: 
      {
        return APP_TOOLTIPS.TOOLTIP_CONCRETE_STRENGTH.Content;
      }
    }
  }

}

const mapState = state => ({
  type: state.main.appType,
  designStandard: Number(state.main.localization.designStandard),
  countryId : Number(state.main.localization.country),

  bonds: state.webServices.material.bonds,
  conditions: state.webServices.material.conditions,
  strengths: state.webServices.material.strengths,
  isPending: state.webServices.material.isPending,
  concreteStrengthValue: state.webServices.material.concreteStrengthValue,

  chosenStrength: state.selectors.material[state.main.appType].concrete.strength,
  chosenCondition: state.selectors.material[state.main.appType].concrete.conditions,
  chosenBond: state.selectors.material[state.main.appType].concrete.bondConditions,
  depth: state.selectors.material[state.main.appType].concrete.thicknessOfConcrete,

  isLightWeightConcrete: (() => (
    state.main.appType === APP_TYPES.REBAR_REINFORCEMENT || 
    state.main.appType === APP_TYPES.WOOD_CONNECTION ?
      null :
      state.selectors.material[state.main.appType].concrete.lightWeightConcrete.active
  ))(),
  lightWeightConcreteLambda: (() => (
    state.main.appType === APP_TYPES.REBAR_REINFORCEMENT ||
    state.main.appType === APP_TYPES.WOOD_CONNECTION ?
      null :
      state.selectors.material[state.main.appType].concrete.lightWeightConcrete.lambda
  ))(),

  strengthUnit: state.main.units.strength,
  distanceUnit: state.main.units.distance,
  isThicknessEnabled: state.options.object.type !== SafetyBarrierObject.types.STAIRS,
  appStatus: state.main.status
});

const mapDispatch = dispatch => ({
  setDepth: (value, unit) => {
    dispatch(setGroundDepth(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)));
  },

  setConcreteStrength: (value, customValue) => dispatch(setGeneralConcreteStrength(value, customValue)),
  setConcreteConditions: value => dispatch(setConcreteConditions(value)),

  setBondConditions: value => dispatch(setBondConditions(value)),

  setLightWeightConcrete: (active, value) => dispatch(setLightWeightConcrete(active, value)),
  
  getConcreteStrengthValue: value => dispatch(getConcreteStrengthValue(value)),
  setConcreteStrengthValue: value => dispatch(setConcreteStrengthValue(value)) // used for custom
});

export default connect(mapState, mapDispatch)(Concrete);



// WEBPACK FOOTER //
// ./src/views/Material/components/Concrete/index.js